import chartCombination from '@disy/cadenza-icons/chart-combination.svg';
import chart from '@disy/cadenza-icons/chart.svg';
import help from '@disy/cadenza-icons/help.svg';
import image from '@disy/cadenza-icons/image-file.svg';
import indicator from '@disy/cadenza-icons/indicator.svg';
import jasperReport from '@disy/cadenza-icons/jasper-report-lg.svg';
import map from '@disy/cadenza-icons/map.svg';
import stepControlIcon from '@disy/cadenza-icons/step-control.svg';
import table from '@disy/cadenza-icons/table.svg';
import text from '@disy/cadenza-icons/text.svg';
import view from '@disy/cadenza-icons/view.svg';
import webpage from '@disy/cadenza-icons/visualization-type-webpage-view.svg';
import extension from '@disy/cadenza-icons/visualization-type.svg';
import { type Icon, type IconOptions, renderIcon } from '@disy/ui/icon';
import { createElement } from '@disy/ui/lit-util';

import i18n from './view-type.properties';

/**
 * Enum of view types.
 *
 * @see net/disy/cadenza/workbook/model/ViewType.java
 */
export const ViewType = {
  TABLE: 'TABLE',
  MAP: 'MAP',
  CHART: 'CHART',
  TEXT: 'TEXT',
  OTHER: 'OTHER',
  IMAGE: 'IMAGE',
  REPORT: 'REPORT',
  EXTENSION: 'EXTENSION',
  CONTROLLER: 'CONTROLLER',
  WEBPAGE: 'WEBPAGE',
} as const;

export type ViewType = keyof typeof ViewType;

export type FrontendViewType = ViewType | 'CHART_COMBINATION';

const TYPE_ICONS: { [key in FrontendViewType]?: string } = {
  MAP: map,
  TABLE: table,
  CHART: chart,
  CHART_COMBINATION: chartCombination,
  TEXT: text,
  OTHER: indicator,
  IMAGE: image,
  REPORT: jasperReport,
  EXTENSION: extension,
  CONTROLLER: stepControlIcon,
  WEBPAGE: webpage,
};

// use the generic view icon to deal with cases where we lack the information to show a more precise one
const GENERIC_VIEW_ICON = view;
const UNKNOWN_TYPE_ICON = help;

export function renderViewTypeIcon(type?: FrontendViewType, options?: IconOptions) {
  const iconMarkup = type ? TYPE_ICONS[type] || UNKNOWN_TYPE_ICON : GENERIC_VIEW_ICON;

  return renderIcon(iconMarkup, {
    label: type && viewTypeI18n(type),
    styleClass: 'view-type-icon',
    ...options,
  });
}

export function viewTypeIcon(type?: FrontendViewType, options?: IconOptions) {
  return createElement<Icon>(renderViewTypeIcon(type, options));
}

export function viewTypeI18n(type: FrontendViewType) {
  return i18n(`<${type}>`);
}
